import { Component, OnInit, TemplateRef } from '@angular/core';
import { Opiniontype } from './opiniontype';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { OpiniontypeService } from './opiniontype.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-opiniontype',
  templateUrl: './opiniontype.component.html',
  styleUrls: ['./opiniontype.component.css']
})
export class OpiniontypeComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Opinion Type';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  opiniontypeForm: FormGroup;
  opiniontypes: Opiniontype[] = [];
  opiniontypesactive: Opiniontype[] = [];
  opiniontype: Opiniontype;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  opiniontypeModalRef: BsModalRef;
  operation: string;
  userid: number;
  opiniontypeid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  constructor(
    private opiniontypeservice: OpiniontypeService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('OpinionType_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('OpinionType_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('OpinionType_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('OpinionType_action');
    } 
  }

  //get f() { return this.userForm.controls; }
  ngOnInit() {
    this.checkIsMenuMapped();
    this.opiniontypeForm = this.formBuilder.group({
      opiniontypeid: [''],
      opiniontype: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }


  key: string = 'opiniontype'; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedopiniontype");
    let data = arrays.find(ob => ob['name'] === 'Opinion Type');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedopiniontype","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedopiniontype",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.opiniontypeModalRef.hide();
  }

  getAll() {
    this.opiniontypes = [];
    this.opiniontypesactive = [];
    this.opiniontypeservice.Get().subscribe(res => {
      this.opiniontypes = res;
      if (this.showallstatus == true) {
        this.opiniontypes.forEach(data => {
          if (data.active == 1) {
            this.opiniontypesactive.push(data);
          }
        });
        this.opiniontypes = [];
        this.opiniontypes = this.opiniontypesactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  getactiveinactive(showallp) {
    this.opiniontypesactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.opiniontypes.forEach(data => {
        if (data.active == 1) {
          this.opiniontypesactive.push(data);
        }
      });
      this.opiniontypes = [];
      this.opiniontypes = this.opiniontypesactive;
    }
    else {
      this.showall = true;
      this.opiniontypes = [];
      this.getAll();
    }
  }

  get g() { return this.opiniontypeForm.controls; }

  Post(opiniontype: Opiniontype) {
    
    this.submitted = true;
    // stop here if form is invalid
    //if (this.opiniontypeForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.opiniontypeForm.errors);
    //}

    if ((opiniontype.opiniontype.trim() == undefined) || (opiniontype.opiniontype.trim() == '')) {
      this.toastr.error('Opinion Type should not be empty');
      return;
    }
    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    opiniontype.opiniontype = opiniontype.opiniontype.trim();
    if (this.operation == 'add') {

      opiniontype.createdby = this.userid;
      msg = "Record Added Successfully";
      this.opiniontypeservice.Post(opiniontype).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.opiniontypeModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      opiniontype.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.opiniontypeservice.Put(opiniontype).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.opiniontypeModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.opiniontypeForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.opiniontypeForm.value.active = 1;
    } else {
      this.opiniontypeForm.value.active = 0
    }
  }

  OpenConfirmTemplate(opiniontype, template: TemplateRef<any>) {
    if (opiniontype.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.opiniontype = opiniontype;

          this.Delete();

        }
        
      });

  }


  Delete() {
    var msg;
    if (this.opiniontype.active == 0) {
      this.opiniontype.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.opiniontype.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.opiniontype.modifiedby = this.userid;
    this.opiniontypeservice.Delete(this.opiniontype).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }



  hidePopup() {
    this.opiniontypeModalRef.hide();
  }
  openOpiniontypeModal(template: TemplateRef<any>, type, opiniontype ?: Opiniontype,) {
    this.operation = type
   
    if (type == 'update') {
      this.opiniontypeForm.controls['opiniontypeid'].setValue(opiniontype.opiniontypeid);
      this.opiniontypeForm.controls['opiniontype'].setValue(opiniontype.opiniontype);
      this.opiniontypeForm.controls['active'].setValue(opiniontype.active);
      this.opiniontype = opiniontype;
    }
    if (type == 'add') {
      this.opiniontypeForm.controls['opiniontypeid'].setValue(0);
      this.opiniontypeForm.controls['opiniontype'].setValue('');
      this.opiniontypeForm.controls['active'].setValue(1);
    }
    this.opiniontypeModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");

  }




}
